export const DELIVERY_METHODS = {
  ONSITE: {
    value: 0,
    label: 'Onsite'
  },
  VIRTUAL: {
    value: 1,
    label: 'Virtual'
  },
  HYBRID: {
    value: 2,
    label: 'Hybrid'
  }
};
